import { AxiosResponse } from "axios";

export default class Listing {
  id: number;
  master_copy_id: number;
  lister_id: number;
  consideration_token_address: string;
  order_parameters: object;
  order_signature: string;
  start_time: string; // Unix time
  end_time: string; // Unix time
  buyer_id: number = 0;
  status: string = "";

  constructor(
    id: number,
    song_id: number,
    lister_id: number,
    consideration_token_address: string,
    order_parameters: object,
    order_signature: string,
    start_time: string,
    end_time?: string,
    buyer_id?: number,
    status?: string
  ) {
    this.id = id;
    this.master_copy_id = song_id;
    this.lister_id = lister_id;
    this.consideration_token_address = consideration_token_address;
    this.order_parameters = order_parameters;
    this.order_signature = order_signature;
    this.start_time = start_time;
    this.end_time = end_time ?? "";
    this.buyer_id = buyer_id ?? 0;
    this.status = status ?? "";
  }

  static fromResponse(
    response: AxiosResponse<ListingDataResponse, any>
  ): Array<Listing> {
    const listings = response.data.listings;
    return listings.map((listing) => {
      return new Listing(
        listing.id,
        listing.master_copy_id,
        listing.lister_id,
        listing.consideration_token_address,
        listing.order_parameters,
        listing.order_signature,
        listing.start_time,
        listing.end_time,
        listing.buyer_id,
        listing.status
      );
    });
  }

  getSeaportListing() {
    return {
      parameters: this.order_parameters,
      signature: this.order_signature,
    };
  }
}

interface ListingDataResponse {
  listings: Listing[];
}
